var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.761,
    cy: 30.9265,
    rx: 30.4367,
    ry: 30.0339,
    fill: "#920583",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3888 17.8937C23.9187 17.1625 23.0388 16.8313 22.2252 17.0875C21.4116 17.3438 20.8571 18.1187 20.8571 19V31H18.9286C17.8618 31 17 31.8938 17 33C17 34.1063 17.8618 35 18.9286 35H20.8571V43C20.8571 44.1063 21.719 45 22.7857 45C23.8525 45 24.7143 44.1063 24.7143 43V35H30.7531L36.6112 44.1125C37.0812 44.8438 37.9612 45.175 38.7748 44.9188C39.5884 44.6625 40.1429 43.8875 40.1429 43.0063V35H42.0714C43.1382 35 44 34.1063 44 33C44 31.8938 43.1382 31 42.0714 31H40.1429V19C40.1429 17.8937 39.281 17 38.2143 17C37.1475 17 36.2857 17.8937 36.2857 19V31H32.8203L24.3888 17.8937ZM35.3877 35H36.2857V36.3937L35.3877 35ZM28.1797 31H24.7143V25.6062L28.1797 31Z",
    fill: "#920583"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRepIcon);
export default __webpack_public_path__ + "static/media/TotalRepIcon.4478b6a822e681b849fc4bbdd9abf178.svg";
export { ForwardRef as ReactComponent };